import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";
import {
  Select,
  Input,
  Form,
  Row,
  Col,
  Card,
  Radio,
  message,
  Button,
  Tooltip,
} from "antd";
import { CALL_API } from "../../../Common/api";
import { ReactComponent as Back } from "../../../../src/assets/images/lets-icons_back.svg";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../../Reusablecomponents/UIButtons";
import styled from "styled-components";
import GoogleMapComponent from "../../../Reusablecomponents/NexusGoogle";
import { useNavigate, useLocation } from "react-router-dom";
import * as turf from "@turf/turf";
import { useSelector } from "react-redux";
import {
  FENCE_STYLE,
  FENCE_TYPE,
  fenceStyleToType,
  fenceTypeToStyle,
} from "../../../Reusablecomponents/fenceStyleConstants";
import { TRAKING_API_BASE } from "../../../Common/traking";

const GreenRadio = styled(Radio)`
  .ant-radio-inner {
    border-color: green; // Change the border color
  }
  .ant-radio-checked .ant-radio-inner {
    background-color: green; // Change the background color when checked
    border-color: green; // Change the border color when checked
  }
  .ant-radio-wrapper {
    color: green; // Change the text color
  }
`;

const Styledashboard = styled.div`
  .title {
    font-weight: 600;
    font-style: Semi Bold;
    font-size: 18px;
    color: #3d3d3d;
    height: 17px;
    margin-top: 6px;
  }
  .subtitle {
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
    color: #6f6c6c;
  }
  .box {
    border: 1px solid #e0e0e0; /* correct border syntax */
    border-radius: 6px;
    padding: 14px 10px;
    margin-bottom: 16px; /* add some spacing between sections */
    background: #fff; /* keep it white for card look */
  }
  .mapcomponent_subcontainer {
    height: calc(100vh - 100px); /* adjust header/footer */
    width: 100%;
    position: relative;
  }
  .container_for_header_subtwo {
    display: flex;
    align-items: center; /* Ensures all items align properly */
    gap: 10px; /* Adds spacing between elements */
    flex-wrap: wrap;
  }
  @media (min-width: 1026px) and (max-width: 1440px) {
    .mapboxgl-map {
      width: 30%;
    }
    .container_map_component {
      background-color:;
      flex-direction: column !important;
    }
    .container_map_subcomponent {
      max-width: 100% !important ;
      flex: 100% !important;
      margin: 9px 0px 9px 0px;
    }
    .map_container_three {
      width: 100% !important ;
    }
  }
  @media (max-width: 768px) {
    .mapboxgl-map {
      width: 40%;
      border-radius: 12px;
    }
  }

  @media (max-width: 1024px) {
    .mapboxgl-map {
      width: 40%;
    }
    .container_map_component {
      background-color:;
      flex-direction: column !important;
    }
    .container_map_subcomponent {
      max-width: 100% !important ;
      flex: 100% !important;
      margin: 9px 0px 9px 0px;
    }
  }
`;
const { Option } = Select;

function NexusGeoDetails() {
  const [form] = Form.useForm();
  const location = useLocation();
  const [Reciepenttype, setReciepenttype] = useState([]);
  const [fenceGroups, setFenceGroups] = useState([]);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const updateAllowed = useMemo(
    () => hasPermission("GEO", "U"),
    [reduxPermissions],
  );
  // const Reciepenttype = [
  //   {
  //     name: "Consignor",
  //     value: 1,
  //     GUID: "d947bc56-14ab-4a1e-abd5-61d62d48c461",
  //   },
  //   {
  //     name: "Transporter",
  //     value: 2,
  //     GUID: "b7da9541-84c8-49a4-9fd3-550633598f5f",
  //   },
  //   {
  //     name: "Consignee",
  //     value: 3,
  //     GUID: "8c6159ce-50f1-4789-9e00-861f250c419e",
  //   },
  // ];
  const mode = location.state?.mode || "view"; // "add" | "edit" | "view"
  const fromEntityManagement = location.state?.fromEntityManagement || false; // flag to check if navigated from EntityManagement
  const [loading, setLoading] = useState(false);
  const [fenceList, setFenceList] = useState([]);
  const [resetCounter, setResetCounter] = useState(0);
  const [isEditing, setIsEditing] = useState(
    mode === "add" || (mode === "edit" && fromEntityManagement),
  );
  const [companyList, setCompanyList] = useState([]);
  const [currentFenceStyle, setCurrentFenceStyle] = useState(
    mode === "add" ? FENCE_STYLE.CIRCLE : FENCE_STYLE.POLYGON, // Default to Circle for creation
  );
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  // Accounts linked to TraKing (other than the operator, MCID 59) are fixed to
  // their own company: it is pre-selected, locked, and used for the save.
  const ownCompanyId =
    userInfo?.MCID !== 59 && userInfo?.NexusCompId
      ? Number(userInfo.NexusCompId)
      : null;
  // The company is locked when creating a fence for a known company (the one
  // chosen on the list page, or the account's own company)
  const companyLocked =
    Boolean(ownCompanyId) || (mode === "add" && Boolean(location.state?.company_id));
  const fenceStyle = Form.useWatch("fstyle", form);
  const selectedCompany = Form.useWatch("company", form);
  const navigate = useNavigate();
  const fetchLocation = async (lat, lon) => {
    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${lon},${lat}.json?access_token=pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow`,
      );
      const data = await response.json();
      return data?.features?.[0]?.place_name || "Unknown Location";
    } catch (error) {
      console.error("Error fetching location:", error);
      return "Unknown Location";
    }
  };

  // Average of a polygon's vertex coordinates - used as a "center" point
  // for polygons (which have no single lat/lng like a circle does).
  const getCentroid = (points) => {
    if (!Array.isArray(points) || points.length === 0) return null;
    const sum = points.reduce(
      (acc, p) => ({
        lat: acc.lat + (Number(p.lat) || 0),
        lng: acc.lng + (Number(p.lng) || 0),
      }),
      { lat: 0, lng: 0 },
    );
    return {
      lat: sum.lat / points.length,
      lng: sum.lng / points.length,
    };
  };

  // Derive the lng/lat/fpath form fields from a fence record's `coordinates`,
  // which is a single {lat, lng} point for circles but an array of vertex
  // points for polygons.
  const getCoordinateFormValues = (stateData) => {
    if (!stateData) return { lng: "", lat: "", fpath: "[]" };
    if (stateData.fence_type === FENCE_TYPE.POLYGON) {
      const points = Array.isArray(stateData.coordinates)
        ? stateData.coordinates
        : [];
      const centroid = getCentroid(points);
      return {
        lng: centroid?.lng ?? "",
        lat: centroid?.lat ?? "",
        fpath: JSON.stringify(points),
      };
    }
    return {
      lng: stateData.coordinates?.lng ?? "",
      lat: stateData.coordinates?.lat ?? "",
      fpath: stateData.coordinates
        ? JSON.stringify([stateData.coordinates])
        : "[]",
    };
  };

  // Build the `coordinates` payload for create/update: an array of vertex
  // points for polygons, or a single {lat, lng} center point for circles.
  const getCoordinatesPayload = (formData) => {
    if (formData?.fstyle === FENCE_STYLE.POLYGON) {
      try {
        return JSON.parse(formData?.fpath || "[]");
      } catch (error) {
        console.error("[getCoordinatesPayload] invalid fpath:", error);
        return [];
      }
    }
    return {
      lat: formData?.lat,
      lng: formData?.lng,
    };
  };
  const fetchAllFenceTypes = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("POST", "geoFence/fence_types", {
        FAgentGUID: userInfo?.ECTSCompId,
      });
      setReciepenttype(data);
    } catch (error) {
      console.error("[fetchAllFenceTypes] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchFenceGroups = useCallback(async (companyId) => {
    if (!companyId) {
      setFenceGroups([]);
      return;
    }
    try {
      const response = await fetch(
        `${TRAKING_API_BASE}/traking/fenceGrouped?company_id=${companyId}`,
        {
          method: "GET",
          headers: {
            "x-api-key": "trackright-secure-api-key-123",
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      setFenceGroups(data?.response || []);
    } catch (error) {
      console.error("[fetchFenceGroups] error:", error);
      setFenceGroups([]);
    }
  }, []);

  useEffect(() => {
    fetchFenceGroups(selectedCompany);
  }, [selectedCompany, fetchFenceGroups]);
  const handleSave = async () => {
    try {
      const values = await form.validateFields(); // get form values
      // map values to API structure
      const formData = {
        name: values.name,
        company: values.company,
        number: values.number,
        desc: values.desc,
        area: values.area,
        type: values.type,
        fpath: values.fpath,
        fstyle: values.fstyle,
        radius: values.radius,
        lng: values.lng,
        lat: values.lat,
        loc: values.loc,
      };
      const savedName = values.name;

      if (mode === "add") {
        await createFences(formData);
      } else {
        // updating → FGUID comes from existing record
        await updateFence(formData, fenceList?.geofence_id);
      }
      setIsEditing(false);
      // Navigate back to EntityManagement if came from there, otherwise go to GeoFence

      navigate("/NexusGeoFence");
    } catch (err) {
      console.error("Error saving fence:", err);
    }
  };

  const fetchAllCompany = useCallback(async () => {
    try {
      setLoading(true);

      const response = await fetch(
        `${TRAKING_API_BASE}/traking/allCompany`,
        {
          method: "GET",
          headers: {
            "x-api-key": "trackright-secure-api-key-123",
            "Content-Type": "application/json",
          },
        },
      );

      const companies = await response.json();

      const all = companies.response || [];
      setCompanyList(
        ownCompanyId
          ? all.filter((c) => Number(c.company_id) === ownCompanyId)
          : all,
      );
    } catch (error) {
      console.error("[fetchAllNexusCompany] error:", error);
    } finally {
      setLoading(false);
    }
  }, [ownCompanyId]);
  useEffect(() => {
    fetchAllCompany();
    fetchAllFenceTypes();
  }, []);
  useEffect(() => {
    if (location.state && companyList?.length) {
      setFenceList(location.state);

      // Update form values when fenceList changes
      form.setFieldsValue({
        name: location.state.name || "",
        company: location.state.company_id || "",
        fstyle: fenceTypeToStyle(location.state.fence_type),
        type: location.state.group_name || "",
        ...getCoordinateFormValues(location.state),
        area: location.state.area_km2 || 0,
        radius: location.state.radius_km || 0,
        loc: location.state.location_name,
        // desc: location.state.FRemark || "",
      });
    }
  }, [location.state, companyList, form]);

  // The Group select holds the group name; TraKing links a fence to its group by id
  const groupIdFor = useCallback(
    (name) => fenceGroups.find((g) => g.group_name === name)?.group_id,
    [fenceGroups],
  );

  const createFences = useCallback(
    async (formData) => {
      try {
        setLoading(true);
        const response = await fetch(
          `${TRAKING_API_BASE}/traking/createFence`,
          {
            method: "POST",
            headers: {
              "x-api-key": "trackright-secure-api-key-123",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              name: formData?.name,
              group_name: formData?.type,
              group_id: groupIdFor(formData?.type),
              company_id: ownCompanyId || formData?.company,
              fence_type: fenceStyleToType(formData?.fstyle),
              radius_km: formData?.radius,
              area_km2: formData?.area,
              location_name: formData?.loc,
              coordinates: getCoordinatesPayload(formData),
              entry_alert: true,
              exit_alert: true,
            }),
          },
        );
        const result = await response.json();
        if (result?.statusCode === 200) {
          message.success("Fence created successfully!");
          navigate("/NexusGeoFence");
        } else {
          console.warn("Creation failed", result?.message);
          message.error(result?.message || "Creation failed");
        }
      } catch (error) {
        console.error("[createFences] error:", error);
      } finally {
        setLoading(false);
      }
    },
    [location.state, navigate, groupIdFor],
  );

  const updateFence = useCallback(
    async (formData, id) => {
      try {
        setLoading(true);
        const response = await fetch(
          `${TRAKING_API_BASE}/traking/updateFence`,
          {
            method: "PUT",
            headers: {
              "x-api-key": "trackright-secure-api-key-123",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              geofence_id: id,
              name: formData?.name,
              group_name: formData?.type,
              group_id: groupIdFor(formData?.type),
              company_id: ownCompanyId || formData?.company,
              fence_type: fenceStyleToType(formData?.fstyle),
              radius_km: formData?.radius,
              area_km2: formData?.area,
              location_name: formData?.loc,
              coordinates: getCoordinatesPayload(formData),
              entry_alert: true,
              exit_alert: true,
            }),
          },
        );
        const result = await response.json();
        if (result?.statusCode === 200) {
          message.success("Fence updated successfully!");
          navigate("/NexusGeoFence");
        } else {
          message.error(result?.message || "Update failed");
        }
      } catch (error) {
        console.error("[updateFence] error:", error);
      } finally {
        setLoading(false);
      }
    },
    [navigate, location.state, groupIdFor],
  );

  // For add mode, empty form, else fill with initialValues
  const getInitialFormValues = (data = {}) => ({
    geofence_id: data.geofence_id,
    name: data.name || "",
    company: data.company_id || "",
    fstyle: fenceTypeToStyle(data.fence_type),
    lng: data.coordinates?.lng || "",
    lat: data.coordinates?.lat || "",
    area: data.area_km2 || 0,
    radius: data.radius_km || 0,
    loc: data.location_name || "",
  });

  const initialValues = mode === "add" ? {} : getInitialFormValues(fenceList);

  useEffect(() => {
    if (location.state && companyList?.length) {
      setFenceList(location.state);

      const initialFenceStyle = fenceTypeToStyle(location.state.fence_type);
      form.setFieldsValue({
        name: location.state.name || "",
        company: location.state.company_id || "",
        fstyle: initialFenceStyle,
        // type:
        //   userInfo?.MCID === 55
        //     ? "cb092e5b-0367-46c3-98ef-89b779687efc" || ""
        //     : location.state.FFenceTypeGUID !== undefined
        //       ? String(location.state.FFenceTypeGUID)
        //       : undefined,
        ...getCoordinateFormValues(location.state),
        area: location.state.area_km2 || 0,
        radius: location.state.radius_km || 0,
        loc: location.state.location_name || "",
      });

      setCurrentFenceStyle(initialFenceStyle);
      if (mode === "edit") {
        setIsEditing(true);
      }
    } else if (mode === "add") {
      // For creation, default to Circle; pre-fill company if passed via navigation
      const prefilledCompany = ownCompanyId || location.state?.company_id;
      form.setFieldsValue({
        fstyle: FENCE_STYLE.CIRCLE,
        ...(prefilledCompany ? { company: prefilledCompany } : {}),
      });
      setCurrentFenceStyle(FENCE_STYLE.CIRCLE);
    }
  }, [location.state, companyList, form, mode]);

  // Add a function to handle the change
  const handleFenceStyleChange = (e) => {
    const newStyle = e.target.value;
    setCurrentFenceStyle(newStyle);
    form.setFieldsValue({
      fstyle: newStyle,
      fpath: "[]",
      radius: 0,
      lng: 0,
      lat: 0,
      area: 0,
      loc: "",
    });
    setResetCounter((prev) => prev + 1); // also clear map drawing
  };

  return (
    <Styledashboard>
      <div style={{ padding: "16px", background: "#f0f2f5" }}>
        <Row gutter={[0, 16]} style={{ margin: 0 }}>
          {/* Left White Box */}
          <Col
            style={{
              flex: "0 0 350px",
              maxWidth: 350,
              minWidth: 350,
              paddingRight: 0,
              paddingLeft: 0,
            }}
          >
            {" "}
            <div className="d-flex justify-content-between align-items-center">
              <Card
                style={{ borderRadius: "12px", height: "100%", width: "100%" }}
              >
                <div className="container_for_header_subtwo">
                  <Back
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigate("/NexusGeoFence");
                    }}
                  />{" "}
                  <p className="title">
                    {mode === "add"
                      ? "Create Fence"
                      : isEditing
                        ? "Edit Fence"
                        : "Details"}
                  </p>
                  {mode !== "add" && !isEditing && (
                    <ButtonFilled
                      type="primary"
                      // disabled={!updateAllowed}
                      onClick={() => {
                        // if (!updateAllowed) return;
                        setIsEditing(true);
                      }}
                    >
                      + Edit
                    </ButtonFilled>
                  )}
                </div>
                <p className="subtitle">
                  {!initialValues?.name ? "Add New Fence" : initialValues?.name}
                </p>{" "}
                {/* Form */}
                <Form
                  layout="vertical"
                  form={form}
                  initialValues={{
                    fstyle: mode === "add" ? FENCE_STYLE.CIRCLE : FENCE_STYLE.POLYGON,
                  }}
                >
                  <div className="box">
                    <Form.Item
                      label="Name"
                      name="name"
                      rules={[
                        {
                          required: true,
                          message: "Name is required",
                        },
                      ]}
                    >
                      <Input disabled={!isEditing} />
                    </Form.Item>
                    <Form.Item
                      label="Company"
                      name="company"
                      rules={[
                        {
                          required: true,
                          message: "Company is required",
                        },
                      ]}
                    >
                      <Select
                        className="w-100"
                        showSearch
                        optionFilterProp="children"
                        allowClear={!companyLocked}
                        disabled={companyLocked}
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {" "}
                        {companyList?.map((type) => (
                          <Option key={type.company_id} value={type.company_id}>
                            {type.company_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      label="Fence Style"
                      name="fstyle"
                      rules={[
                        {
                          required: true,
                          message: "Fence Style is required",
                        },
                      ]}
                    >
                      <Radio.Group
                        disabled={!isEditing}
                        onChange={handleFenceStyleChange}
                        value={form.getFieldValue("fstyle")}
                      >
                        <GreenRadio value={FENCE_STYLE.CIRCLE}>Circle</GreenRadio>
                        <GreenRadio value={FENCE_STYLE.POLYGON}>Polygon</GreenRadio>
                      </Radio.Group>
                    </Form.Item>
                    <Form.Item
                      label="Group"
                      name="type"
                      rules={[
                        {
                          required: true,
                          message: "Type is required",
                        },
                      ]}
                    >
                      <Select
                        className="w-100"
                        showSearch
                        optionFilterProp="children"
                        allowClear
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {fenceGroups.map((group) => (
                          <Option key={group.group_id} value={group.group_name}>
                            {group.group_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="box">
                    {/* lng/lat/fpath are auto-populated by drawing on the map
                        and sent as-is in the create/update payload; they are
                        surfaced read-only via the "Coordinates" field below */}
                    <Form.Item name="lng" hidden>
                      <Input />
                    </Form.Item>
                    <Form.Item name="lat" hidden>
                      <Input />
                    </Form.Item>
                    <Form.Item name="fpath" hidden>
                      <Input />
                    </Form.Item>

                    <Form.Item
                      noStyle
                      shouldUpdate={(prev, curr) =>
                        prev.fstyle !== curr.fstyle ||
                        prev.lng !== curr.lng ||
                        prev.lat !== curr.lat ||
                        prev.fpath !== curr.fpath
                      }
                    >
                      {({ getFieldValue }) => {
                        const style = getFieldValue("fstyle");
                        if (style === FENCE_STYLE.POLYGON) {
                          let points = [];
                          try {
                            const raw = getFieldValue("fpath");
                            points = raw ? JSON.parse(raw) : [];
                          } catch {
                            points = [];
                          }
                          if (
                            !points.length &&
                            Array.isArray(location.state?.coordinates)
                          ) {
                            points = location.state.coordinates;
                          }
                          const coordsText = points
                            .map(
                              (p, i) =>
                                `${i + 1}. Lat: ${p.lat}, Lng: ${p.lng}`,
                            )
                            .join("\n");
                          return (
                            <Form.Item label="Coordinates">
                              <Input.TextArea
                                rows={4}
                                value={coordsText}
                                disabled
                              />
                            </Form.Item>
                          );
                        }
                        const lng = getFieldValue("lng");
                        const lat = getFieldValue("lat");
                        return (
                          <Form.Item label="Coordinates">
                            <Input
                              value={`Lat: ${lat || "-"}, Lng: ${lng || "-"}`}
                              disabled
                            />
                          </Form.Item>
                        );
                      }}
                    </Form.Item>

                    <Form.Item label="Area (Km²)" name="area">
                      <Input disabled={!isEditing || fenceStyle === FENCE_STYLE.CIRCLE} />
                    </Form.Item>

                    {/* Conditionally show Radius if Circle is selected */}
                    <Form.Item
                      noStyle
                      shouldUpdate={(prev, curr) => prev.fstyle !== curr.fstyle}
                    >
                      {({ getFieldValue, setFieldsValue }) =>
                        getFieldValue("fstyle") === FENCE_STYLE.CIRCLE ? (
                          <Form.Item label="Radius (Km)*" name="radius">
                            <Input
                              disabled={!isEditing}
                              placeholder="3"
                              onChange={(e) => {
                                const newRadius =
                                  parseFloat(e.target.value) || 3;
                                setFieldsValue({ radius: newRadius });
                              }}
                            />
                          </Form.Item>
                        ) : null
                      }
                    </Form.Item>

                    <Form.Item label="Location" name="loc">
                      <Input.TextArea
                        rows={2}
                        disabled={!isEditing || fenceStyle === FENCE_STYLE.CIRCLE}
                      />
                    </Form.Item>
                  </div>
                  {/* Action Buttons (only in Edit/Add mode) */}
                  {isEditing && (
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button
                        style={{
                          cursor: "pointer",
                          marginTop: "22px",
                          backgroundColor: "#EF8686",
                          borderRadius: "26px",
                          padding: "9px 16px",
                          border: "none",
                          color: "white",
                          fontWeight: 500,
                        }}
                        onClick={() => form.resetFields()}
                      >
                        Reset
                      </Button>
                      <Buttontransparent
                        style={{ cursor: "pointer", marginTop: "20px" }}
                        onClick={() => {
                          setResetCounter((prev) => prev + 1); // bump counter on each click
                          form.setFieldsValue({
                            fpath: "[]",
                            radius: 0,
                            lng: 0,
                            lat: 0,
                            area: 0,
                            loc: "",
                          }); // clear form too
                        }}
                      >
                        Redraw
                      </Buttontransparent>
                      <ButtonFilled
                        style={{
                          cursor: "pointer",
                          marginTop: "20px",
                          marginLeft: "-4px",
                        }}
                        onClick={handleSave}
                        loading={loading}
                      >
                        Save
                      </ButtonFilled>
                    </div>
                  )}
                </Form>
              </Card>
            </div>
          </Col>

          {/* Right White Box */}
          <Col
            style={{ flex: 1, minWidth: 0, paddingLeft: 15, paddingRight: 0 }}
          >
            <div className="mapcomponent_subcontainer">
              <GoogleMapComponent
                showSearch={true}
                mapSize="large"
                resetTrigger={resetCounter}
                className="map_container_three"
                drawingMode={fenceStyleToType(form.getFieldValue("fstyle"))}
                fenceData={fenceList}
                fenceStyle={form.getFieldValue("fstyle") || currentFenceStyle}
                radius={parseFloat(form.getFieldValue("radius")) || 3}
                onPathChange={(points) => {
                  // store polygon path without closing duplication
                  form.setFieldsValue({ fpath: points || "[]" });
                }}
                initialPolygon={
                  Array.isArray(location.state?.coordinates)
                    ? location.state.coordinates
                    : location.state?.coordinates
                      ? [location.state.coordinates]
                      : location.state?.FPath
                        ? JSON.parse(location.state.FPath)
                        : null
                }
                onPolygonDraw={async (points) => {
                  if (points.length > 0) {
                    const firstPoint = points[0];
                    const lastPoint = points[points.length - 1];

                    // Ensure polygon is closed
                    const isClosed =
                      firstPoint.lat === lastPoint.lat &&
                      firstPoint.lng === lastPoint.lng;
                    const closedPoints = isClosed
                      ? points
                      : [...points, firstPoint];

                    // Clean path (remove duplicate last point)
                    const fPathClean = closedPoints.slice(0, -1);

                    // Convert to Turf polygon
                    const turfPolygon = turf.polygon([
                      closedPoints.map((p) => [p.lng, p.lat]),
                    ]);

                    //  Area in square meters
                    const areaSqMeters = turf.area(turfPolygon);

                    // Convert to km²
                    const areaSqKm = areaSqMeters / 1_000_000;

                    // Use the polygon's centroid (not just the first vertex)
                    // as its "center" for the location lookup
                    const centroid = getCentroid(fPathClean) || firstPoint;

                    // Fetch location name
                    const locName = await fetchLocation(
                      centroid.lat,
                      centroid.lng,
                    );

                    form.setFieldsValue({
                      area: Math.round(areaSqKm * 100) / 100 || 0, // round to 2 decimals
                      loc: locName || "",
                      fpath: JSON.stringify(fPathClean) || "[]",
                      radius: 0,
                      lng: centroid.lng || 0,
                      lat: centroid.lat || 0,
                    });
                  }
                }}
                onCircleDraw={async (circleData) => {
                  if (circleData) {
                    // Fetch location name
                    const locName = await fetchLocation(
                      circleData.center.lat,
                      circleData.center.lng,
                    );

                    form.setFieldsValue({
                      area: Math.round(circleData.area * 100) / 100 || 0, // round to 2 decimals
                      loc: locName || "",
                      fpath: JSON.stringify([circleData.center]), // Store center point
                      radius: circleData.radius,
                      lng: circleData.center.lng || 0,
                      lat: circleData.center.lat || 0,
                    });
                  }
                }}
                isEditing={mode === "add" || isEditing}
              />
            </div>
          </Col>
        </Row>
      </div>
    </Styledashboard>
  );
}

export default NexusGeoDetails;
